import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GrupoInserirComponent } from './grupo-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: GrupoInserirComponent }    
    ])],
    exports: [RouterModule]
})
export class GrupoInserirRoutingModule { }
